import { z } from 'zod';
/**
 * Severity (PRD VS-014, TechSpec §5.1): a number on the wire and in the
 * database, a name in the UI. This is the only place the mapping lives.
 */
export const SEVERITY_NAMES = ['info', 'ok', 'warn', 'error', 'critical'];
export const SEVERITY = {
    info: 0,
    ok: 1,
    warn: 2,
    error: 3,
    critical: 4,
};
export const SeveritySchema = z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
]);
export const severityName = (severity) => SEVERITY_NAMES[severity];
/** An event as the API serves it (TechSpec §3.2). Immutable once written. */
export const EventSchema = z.object({
    /** bigint in the database; a string on the wire so no precision is lost. */
    id: z.string(),
    ts: z.iso.datetime({ offset: true }),
    sourceId: z.uuid(),
    kind: z.string(),
    severity: SeveritySchema,
    title: z.string(),
    body: z.string().nullable(),
    payload: z.record(z.string(), z.unknown()),
    correlationKey: z.string().nullable(),
    linkUrl: z.string().nullable(),
});
export const EventListResponseSchema = z.object({
    events: z.array(EventSchema),
    /** Pass back as `before` to get the next (older) page; null at the end. */
    nextBefore: z.string().nullable(),
});
export const EventQuerySchema = z.object({
    sourceId: z.uuid().optional(),
    kind: z.string().max(200).optional(),
    /** e.g. 'erp.' — every kind starting with it. */
    kindPrefix: z.string().min(1).max(200).optional(),
    minSeverity: z.coerce.number().int().min(0).max(4).optional(),
    /** Event id: only events older than this one. */
    before: z.string().regex(/^\d+$/).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=events.js.map